import React from 'react';
import { InputNumber } from 'antd';
import styled from 'styled-components';

const StyledInputNumber = styled(InputNumber)`
  width: 100%;

  .ant-input-number-affix-wrapper {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const MoneyInput = (props) => (
  <StyledInputNumber
    formatter={(value) => value && `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
    min={0}
    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
    precision={2}
    addonBefore="$"
    width={'100%'}
    {...props}
  />
);

export { MoneyInput };
